import React from 'react'

import { connect } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'

const PermissionRoute = ({ component: Component, render, permission, isAdmin, ...rest }) => {
  const isAuthorized = !!permission?.is_view
  return (
    <Route
      {...rest}
      render={props => {
        return isAuthorized ? (
          Component ? (
            <Component {...props} pagePermission={permission} isAdmin={isAdmin} />
          ) : (
            render({ ...props, pagePermission: permission, isAdmin: isAdmin })
          )
        ) : (
          <Redirect to={'/'} />
        )
      }}
    />
  )
}

const mapStateToProps = (state, ownProps) => {
  let pagePermission = state.auth.permissions.find(page => page.url === ownProps.urlCode)
  return {
    permission: pagePermission,
    isAdmin: state.auth.isAdmin
  }
}

export default connect(mapStateToProps)(PermissionRoute)
